import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubSink } from 'subsink';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule, ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { ProfilePicture } from 'src/app/shared/models/profile-picture.model';
import { DriverStateModel } from 'src/app/registration/state/registration.state';
import { ActivatedRoute, Router } from '@angular/router';
import { Driver } from 'src/app/shared/models/driver.model';
import { first, tap, switchMap, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { ErrorModel } from 'src/app/shared/models/error.model';
import { DateTimeService } from 'src/app/shared/date-time-convertor/date-time.service';
import { FrameNavigationService } from 'src/app/frame/shared/frame-navigation.service';
import { DRIVER_TYPE_MAP } from 'src/app/driver-qualification-files/constants';
import { License } from 'src/app/shared/models/license.model';
import { ShipmentsDataService } from 'src/app/shipments/shared/shipments-data.service';
import { SHIPMENTS_ROUTE, SHIPMENTS_ROUTE_MY_STATUS } from 'src/app/shipments/shared/routes';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ProfileLoadingComponent } from './profile-loading/profile-loading.component';
import { ModernCircularProgressComponent } from '../../shared/modern-circular-progress/modern-circular-progress.component';
import { WizardStateService } from '../shared/wizard-state.service';
import { ROUTE_DRIVER_JOB_APPLY } from 'src/app/driver-job/shared/routes';

const DEFAULT_PROFILE_IMAGE = '/assets/images/default-profile-picture.png';
const DRIVER_QUALIFICATION_FILE = 'DriverQualificationsFile';

const ACTION_GET_PROFILE_IMAGE = 'get profile image';
const DISABLE_TOP_LOADING_BAR = true;
const LICENSE_DOCUMENT_TYPE = 'DriverLicense';
const PRCARD_DOCUMENT_TYPE = 'PRCard';
const TRAINING_CERTI_DOCUMENT = 'TrainingCertificate';
const PASSPORT_DOCUMENT_TYPE = 'Passport';
const USVISA_DOCUMENT_TYPE = 'USVisa';
const CANADA_VISA_DOCUMENT_TYPE = 'CanadaVisa';
const ADDITIONAL_DOCUMENTS = [
  PRCARD_DOCUMENT_TYPE,
  // TRAINING_CERTI_DOCUMENT,
  PASSPORT_DOCUMENT_TYPE
];
const SHIPMENT_STATUS_CONFIRMATION_PENDING = 'confirmation pending';

const UPLOADED_STATUS = 'uploaded';
export interface DialogData {
  firstName: string;
  lastName: string;
}
import { ProfileAction } from '../shared/profile-action.model';
@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule,
      MatProgressSpinnerModule,
      ProfileLoadingComponent,
      ModernCircularProgressComponent,
    ]
})
export class ProfileComponent implements OnInit, OnDestroy {
  isProfileContentReady: boolean = false;
  isRequireInfoReady: boolean = false;
  profilePicture: ProfilePicture = new ProfilePicture();
  loading: boolean;
  errorMessage: string;
  driver: DriverStateModel;
  notifications: Notification[];
  identityCheck: Notification;
  identityCheckReview: Notification;
  insurance: Notification;
  driverAbstract: Notification;
  medicalExamination: Notification;
  driveTest: Notification;
  resume: Notification;
  profileSectionCompletionCount: number;
  totalRequiredProfileSectionCount: number = 7;
  singleOpen: number;
  driverTypeInstruction: string;
  profileForReview: boolean;
  driverStatus: string;
  isCarrierDriver: boolean;
  totalAdditionalInfoCount = 5;
  driverName: string;
  driverEmail: string;
  driverId: string;
  profilePicturePath: any;
  requiredInformation: ProfileAction[] = [];
  additionalInformation: ProfileAction[] = [];
  trainingsAndCerifications: ProfileAction[] = [];
  mode: ProgressSpinnerMode = 'determinate';
  showPercentage = 0;
  requiredCompleted = 0;
  additionalRequired = 0;
  driverType: string;
  licenseDetails: License;
  latestShipment;
  isDriverProfileIncomplete: boolean;
  requiredExpanded: boolean = true;
  additionalExpanded: boolean = true;
  private subs = new SubSink();
  carrierCompanyId: string;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly registrationService: RegistrationService,
    private readonly dateTimeService: DateTimeService,
    private readonly router: Router,
    private readonly frameNavigationService: FrameNavigationService,
    private readonly shipmentDataService: ShipmentsDataService,
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer,
    private readonly wizardStateService: WizardStateService,
    @Inject('environmentData') public environment: any
  ) {
    this.loading = false;
    this.errorMessage = undefined;
  }

  ngOnInit(): void { 
    this.isCarrierDriver = this.registrationService.getDriver()?.companyAssociatedId ? true : false;
    this.isDriverProfileIncomplete = this.checkIfDriverProfileIncomplete();
    this.subs.sink = this.registrationService.loadDriver(DISABLE_TOP_LOADING_BAR).subscribe((response: Driver) => {
      if (response) {
        this.loadProfileImage();
        this.getLicense(response);
      }
    });
    this.getNewShipments();
  }
  getNewShipments(): void {
    const dispatcherContact = this.registrationService.getDispatcherContact();
    if (dispatcherContact && dispatcherContact.id) {
      const driverId = this.registrationService.getDriver()?.id;

      this.shipmentDataService
        .fetchMyShipments(driverId)
        .pipe(
          first(),
          tap(response => {
            const confirmationShipments = response?.filter(
              shipment => shipment.status === SHIPMENT_STATUS_CONFIRMATION_PENDING
            );
            const latestShipment = confirmationShipments?.sort(
              (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
            );
            if (latestShipment?.length) {
              this.latestShipment = latestShipment[0];
            }
          })
        )
        .subscribe();
    }
  }
  onNavigateToPersonalInformation(): void {
    this.registrationService.navigateToPersonalInformation(this.activatedRoute);
  }
  navigateToShipmentDetail(shipment: any): void {
    let path = `/${SHIPMENTS_ROUTE}/${SHIPMENTS_ROUTE_MY_STATUS}/${shipment.id}`;
    this.router.navigate([path]);
  }
  closeShipmentNotification(): void {
    this.latestShipment = undefined;
  }

  onImageError(event: any): void {
    // Fallback to default image
    this.profilePicturePath = DEFAULT_PROFILE_IMAGE;
  }

  onImageLoad(event: any): void {
    // Image loaded successfully
  }
  private bindData(response: Driver): void {
    this.driverType = DRIVER_TYPE_MAP[response.companyDriverType];
    this.driverName = `${response.firstName} ${response.lastName}`;
    this.driverEmail = response.email;
    this.driverId = response.driverID;
    this.requiredInformation = this.loadRequiredInformation(response);
    this.additionalInformation = this.loadAdditionalInformation(response);
    const completeValues = this.requiredInformation.filter(element => element.isComplete);
    this.showPercentage = +((+completeValues?.length / this.totalRequiredProfileSectionCount) * 100).toFixed(0);
    this.requiredCompleted = completeValues?.length;
    const completeAdditionalValues = this.additionalInformation.filter(element => element.isComplete);
    this.additionalRequired = completeAdditionalValues?.length;
    this.driverStatus = response.identityStatus;
    this.additionalExpanded = this.requiredCompleted === this.totalRequiredProfileSectionCount;

    if (this.wizardStateService.isActive() && !this.wizardStateService.isProfileIdentityComplete()) {
      this.wizardStateService.syncSteps(this.requiredInformation);
    }

    this.isRequireInfoReady = true;
  }

  onRequiredStepClick(step: ProfileAction, index: number): void {
    this.wizardStateService.activate(this.requiredInformation, index);
    step.clickHandler();
  }
  private loadProfileImage(): void {
    this.registrationService
      .loadProfileImageThumbnail(DISABLE_TOP_LOADING_BAR)
      .pipe(
        switchMap((res: any) => {
          if (res && res.fileUrl) {
            // Fetch the image as blob to bypass CORS issues
            return this.http.get(res.fileUrl, { responseType: 'blob' }).pipe(
              tap((blob: Blob) => {
                const objectURL = URL.createObjectURL(blob);
                this.profilePicturePath = this.sanitizer.bypassSecurityTrustUrl(objectURL);
              }),
              catchError((error: any) => {
                this.profilePicturePath = DEFAULT_PROFILE_IMAGE;
                return of(null);
              })
            );
          } else {
            this.profilePicturePath = DEFAULT_PROFILE_IMAGE;
            return of(null);
          }
        }),
        catchError((error: any) => {
          this.profilePicturePath = DEFAULT_PROFILE_IMAGE;
          this.isProfileContentReady = true;
          return of(false);
        }),
        finalize(() => {
          this.loading = false;
          this.isProfileContentReady = true;
        })
      )
      .subscribe();
  }
  private getLicense(driverResponse): void {
    const license: any = this.registrationService.getLicenseStore();
    if (license) {
      this.licenseDetails = license;
    }
    this.bindData(driverResponse);
    this.carrierCompanyId = sessionStorage.getItem('carrierCompanyId');
    if (this.carrierCompanyId && Number(this.showPercentage) === 100) {
      setTimeout(() => {
        this.router.navigate([`/${ROUTE_DRIVER_JOB_APPLY}`]);
      }, 500);
    }
  }
  private loadRequiredInformation(driverInfo: Driver): ProfileAction[] {
    return [
      {
        displayName: 'Personal Profile',
        clickHandler: () => {
          this.registrationService.navigateToPersonalInformation(this.activatedRoute);
        },
        order: 1,
        isComplete: !this.checkIfDriverProfileIncomplete()
      } as ProfileAction,
      {
        displayName: 'Driver License',
        clickHandler: () => {
          this.registrationService.onNavigateToLicense(this.activatedRoute);
        },
        order: 2,
        isComplete: driverInfo.licenseRequirementsCompleted || false
      } as ProfileAction,
      {
        displayName: 'Employment History',
        clickHandler: () => {
          this.registrationService.navigateToEmploymentHistory(this.activatedRoute);
        },
        order: 3,
        isComplete: driverInfo.employmentRequirementsCompleted || false
      } as ProfileAction,
      {
        displayName: 'Residence History',
        clickHandler: () => {
          this.registrationService.navigateToResidenceHistory(this.activatedRoute);
        },
        order: 4,
        isComplete: driverInfo.residenceHistoryRequirementsCompleted || false
      } as ProfileAction,
      {
        displayName: 'Driving Experience',
        clickHandler: () => {
          this.registrationService.navigateToDrivingExperience(this.activatedRoute);
        },
        order: 5,
        isComplete: driverInfo.experienceRequirementsCompleted || false
      } as ProfileAction,
      {
        displayName: 'Accident Records',
        clickHandler: () => {
          this.registrationService.navigateToAccidentRecords(this.activatedRoute);
        },
        order: 6,
        isComplete: driverInfo.accidentsRequirementsCompleted || false
      } as ProfileAction,
      {
        displayName: 'Traffic Convictions',
        clickHandler: () => {
          this.registrationService.onNavigateToTrafficConvictions(this.activatedRoute);
        },
        order: 7,
        isComplete: driverInfo.convictionsRequirementsCompleted || false
      } as ProfileAction
    ].sort((first, second) => first.order - second.order);
  }

  private loadAdditionalInformation(driverInfo: Driver): ProfileAction[] {
    return [
      { 
        displayName: 'Documents',
        clickHandler: () => {
          //this.registrationService.navigateToDocuments(this.activatedRoute);
          this.frameNavigationService.navigateToMyDocuments();
        },
        order: 1,
        isComplete: this.checkAdditionalDocumentExist(driverInfo)
      } as ProfileAction,
      {
        displayName: 'Incorporation / WSIB',
        clickHandler: () => {
          this.registrationService.navigateToIncorporation(this.activatedRoute);
        },
        order: 2,
        isComplete: this.checkWorkPlaceSafetyExist(driverInfo)
      } as ProfileAction,
      {
        displayName: 'Education',
        clickHandler: () => {
          this.registrationService.navigateToEducation(this.activatedRoute);
        },
        order: 3,
        isComplete: this.checkEducationExist(driverInfo)
      } as ProfileAction,
      {
        displayName: 'Preferences',
        clickHandler: () => {
          this.registrationService.navigateToPreferences(this.activatedRoute);
        },
        order: 4,
        isComplete: this.checkPrefrenceExist(driverInfo)
      } as ProfileAction,
      {
        displayName: 'Insurance',
        clickHandler: () => {
          this.registrationService.navigateToInsurance(this.activatedRoute);
        },
        order: 5,
        isComplete: false
      } as ProfileAction
    ].sort((first, second) => first.order - second.order);
  }
  private checkAdditionalDocumentExist(driver: Driver): boolean {
    if (driver && driver?.notification) {
      const documents = driver.notification.filter(notificationModal => {
        return ADDITIONAL_DOCUMENTS.some((doc: any) => {
          return doc === notificationModal.type;
        });
      });
      // Look for visa doc based on license - country
      let visaDocument = [];
      const docType =
        this.licenseDetails?.issuingCountry === 'us'
          ? CANADA_VISA_DOCUMENT_TYPE
          : this.licenseDetails?.issuingCountry === 'ca'
          ? USVISA_DOCUMENT_TYPE
          : '';
      if (docType) {
        visaDocument = driver.notification.filter((doc: any) => {
          return doc.type === docType;
        });
      }

      return documents?.length === ADDITIONAL_DOCUMENTS.length && visaDocument.length > 0;
    }
  }
  private checkEducationExist(driver: Driver): boolean {
    return !!driver?.education;
  }
  private checkPrefrenceExist(driver: Driver): boolean {
    return Object.keys(driver?.preference).length !== 0;
  }
  private checkWorkPlaceSafetyExist(driver: Driver): boolean {
    return Object.keys(driver?.workplaceSafety).length !== 0;
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  navigateToDriverQualification() {
    this.frameNavigationService.navigateToDriverQualificaton();
  }

  private checkIfDriverProfileIncomplete(): boolean {
    const {
      firstName,
      lastName,
      birthday,
      phoneNumber,
      gender,
      address,
      emergencyContacts
    } = this.registrationService.getDriver();

    if (!firstName || !lastName || !birthday || !phoneNumber || !gender || !address) {
      return true;
    }

    if (!emergencyContacts || emergencyContacts.length === 0) {
      return true;
    }

    return false;
  }
}
